<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/factorial-material-list">
                    <icon name="paperclip"></icon>
                    รายการวัสดุอุปกรณ์โรงงานทั้งหมด
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/factorial-material-import">
                    <icon name="download"></icon>
                    นำเข้าวัสดุอุปกรณ์โรงงาน
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/factorial-material-export">
                    <icon name="upload"></icon>
                    เบิกวัสดุอุปกรณ์โรงงาน
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/factory-type-special">
                    <icon name="arrow-circle-right"></icon> หมวดสินค้าโรงงาน(เฉพาะ)
                </b-nav-item>
            </b-nav>

        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "factorial-material-layout"
    }
</script>

<style scoped>

</style>
